import { render, staticRenderFns } from "./requisition_list.vue?vue&type=template&id=3322d764&scoped=true&"
import script from "./requisition_list.vue?vue&type=script&lang=js&"
export * from "./requisition_list.vue?vue&type=script&lang=js&"
import style0 from "./requisition_list.vue?vue&type=style&index=0&id=3322d764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322d764",
  null
  
)

export default component.exports